<!-- 绑定设备 -->
<template>
  <div>
    <el-dialog
      :title="`绑定设备(已选${selfList.length})`"
      width="1200px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main">
        <vxe-grid size="mini" border :height="256" :data="noChooseList" :columns="showColumn">
          <!-- slot_header -->
          <template #header_input="{ column }">
            <c-table-header
              :title="column.title"
              :field="column.field"
              :url="headerFilterUrl"
              @change="headerFilterChange"
            />
          </template>

          <!-- slot_default -->
          <template #default_operate="{ row }">
            <el-link
              size="mini"
              type="success"
              icon="vxe-icon-lock-fill"
              title="绑定"
              @click="itemAdd(row)"
            >
              绑定
            </el-link>
          </template>
        </vxe-grid>
        <vxe-grid class="m-t-10" size="mini" :height="256" :data="selfList" :columns="activeColumn">
          <!-- slot_default -->
          <template #default_set="{ rowIndex }">
            <div>
              <el-link
                size="mini"
                type="primary"
                icon="vxe-icon-setting"
                title="价格设置"
                @click="itemSet(rowIndex)"
              >
                价格设置
              </el-link>
            </div>
          </template>
          <template #default_operate="{ rowIndex }">
            <el-link
              size="mini"
              type="danger"
              icon="vxe-icon-unlock-fill"
              title="解绑"
              @click="itemDelete(rowIndex)"
            >
              解绑
            </el-link>
          </template>
        </vxe-grid>
      </div>

      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>

    <!-- 弹窗-设置价格 -->
    <PopupSetPrice
      v-if="isShowPopupSetPrice"
      :show.sync="isShowPopupSetPrice"
      :list="selfList[activeSheBeiIndex].she_bei_mu_ban_list"
      type="价格"
      isFromSheBei
      @success="setPriceSuccess"
    />
  </div>
</template>

<script>
import PopupSetPrice from './popup-set-price'
export default {
  components: {
    PopupSetPrice
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      selfData: {},
      selfList: {},
      allList: [],
      headerFilterUrl: '/admin/gcvip/sheBei/searchHeard',
      filterData: {},
      showColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        { field: 'category1', title: '一级类目', slots: { header: 'header_input' } },
        { field: 'category2', title: '二级类目', slots: { header: 'header_input' } },
        { field: 'category3', title: '三级类目', slots: { header: 'header_input' } },
        { field: 'category4', title: '四级类目', slots: { header: 'header_input' } },
        {
          field: 'name',
          title: '商品设备',
          width: 300,
          slots: { header: 'header_input' }
        },
        { title: '操作', slots: { default: 'default_operate' } }
      ],
      activeColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        { field: 'category1', title: '一级类目' },
        { field: 'category2', title: '二级类目' },
        { field: 'category3', title: '三级类目' },
        { field: 'category4', title: '四级类目' },
        { field: 'name', title: '商品设备', width: 200 },
        { title: '模板价格设置', width: 100, slots: { default: 'default_set' } },
        { title: '操作', slots: { default: 'default_operate' } }
      ],
      isShowPopupSetPrice: false,
      activeSheBeiIndex: ''
    }
  },
  computed: {
    // 未选择数据列表
    noChooseList() {
      let result = []
      this.allList.forEach((itemSt) => {
        let isNotRepect = this.selfList.every((itemNd) => {
          return itemSt.id !== itemNd.id
        })
        if (isNotRepect) result.push(this.$util.deepCopy(itemSt))
      })
      return result
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.selfList = this.$util.deepCopy(this.list)
    this.getMuBanAllList()
  },
  methods: {
    // 头部筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.getMuBanAllList()
    },
    // 获取所有设备
    getMuBanAllList() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/sheBei/list',
        data: {
          filterData: this.filterData,
          pageSize: this.$constant.pageMax,
          sortData: {
            id: 'desc'
          }
        }
      }).then((res) => {
        if (res.status === 200) {
          this.allList = res.data.page.list
        }
      })
    },
    // 项-绑定
    itemAdd(row) {
      let result = this.$util.deepCopy(row)
      this.selfList.push(result)
    },
    // 项-解绑
    itemDelete(index) {
      this.selfList.splice(index, 1)
    },
    // 项-设置
    async itemSet(index) {
      this.activeSheBeiIndex = index
      this.isShowPopupSetPrice = true
    },
    // 设置价格-成功
    setPriceSuccess(val) {
      this.selfList[this.activeSheBeiIndex].she_bei_mu_ban_list = this.$util.deepCopy(val)
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$emit('update:list', this.selfList)
      this.popupCancel()
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  /deep/ .el-link {
    vertical-align: inherit;
  }
}
</style>
